<script setup>
import { useI18n } from 'vue-i18n';

import { XCardInteractive } from '@clicksign/excalibur';

const emit = defineEmits(['click']);

const { t } = useI18n();
</script>

<template>
  <div
    id="home-renew-certificate"
    :class="$style.homeRenewCertificate"
  >
    <h2 :class="$style.title">
      {{ t('home.renew_certificate.title') }}
    </h2>

    <p :class="$style.subtitle">
      {{ t('home.renew_certificate.subtitle') }}
    </p>

    <XCardInteractive
      :title="t('home.renew_certificate.validate_with_document.title')"
      :cta-text="t('home.renew_certificate.validate_with_document.button')"
      icon="file-lines"
      size="large"
      width="960px"
      @click="emit('click', $event)"
    >
      {{ t('home.renew_certificate.validate_with_document.description') }}
    </XCardInteractive>
  </div>
</template>

<style lang="scss" module>
.homeRenewCertificate {
  display: flex;
  align-items: center;
  flex-direction: column;

  .title {
    margin-bottom: var(--space-small-x);
    font-size: var(--font-size-large-x);
    text-align: center;
  }

  .subtitle {
    font-size: var(--font-size-medium);
    text-align: center;
  }
}
</style>
